export const getShData = (data) => {
  if (!data) return null;
  return data?.MDB?._SH_ || null;
};
